import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { AuthService } from './@services/auth.service';
import { AuthGuard } from './@guards/auth.guard';
import localeId from '@angular/common/locales/id';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeId);

export function configFactory(user: AuthService) {
    return () => user.load();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    GraphQLModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase, 'undiknas-cloud'),
  ],
    providers: [AuthGuard, AuthService, {
        provide: APP_INITIALIZER,
        useFactory: configFactory,
        deps: [AuthService],
        multi: true
    },
    { provide: LOCALE_ID, useValue: 'id-ID' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
